
import { useStore } from '@/store'
import { AppMutation } from '@/store/types'
import { MessageBoxActionType, MessageBoxEvent } from '@/types/MessageBox'
import { EventBuss } from '@/types/global'
import { Emitter, computed, defineComponent, inject, onMounted, ref } from 'vue'

export default defineComponent({
    setup() {
        const emitter = inject('emitter') as Emitter
        const store = useStore()

        const avatar = ref(-1)
        const avatars = ref([
            1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
            20, 21
        ])

        onMounted(() => {
            avatar.value = currentAvatar.value
        })

        const close = () => {
            const _evt: MessageBoxEvent = {
                type: MessageBoxActionType.close,
                name: 'avatar'
            }
            emitter.emit(EventBuss.DIALOG, _evt)
        }

        const confirm = () => {
            store.commit(AppMutation.SET_AVATAR, avatar.value)
            close()
        }

        const setAvatar = (a: number) => {
            if (avatar.value !== a) avatar.value = a
        }

        const currentAvatar = computed((): number => store.getters['avatar'])

        return {
            avatar,
            avatars,
            setAvatar,
            close,
            confirm
        }
    }
})
